import React from "react";
import styles from "../styles";
import localStyles from "./styles";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Button } from "@material-ui/core";
import Select from "../../../../../common/StyledSelect";
import { compose } from "recompose";
import {
  Drop_Hook_Move_Page_Names,
  DROP_TRAILER_OPTIONS,
  STOP_TYPES,
} from "../../constants";
import constants from "../../DispatchPanel/constants";
import TrailerDropForm from "./TrailerDropForm";
import isEqual from "lodash.isequal";

class TrailerDropDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dropType: DROP_TRAILER_OPTIONS[0].value,
      trailerNumber: "",
      trailers: [],
      shipmentData: {},
      filteredStops: [],
    };
  }

  componentDidMount() {
    this.updatedTrailersData();
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.routeData, this.props.routeData)) {
      this.updatedTrailersData();
    }
  }

  updatedTrailersData = () => {
    const trailers = this.getCurrentTrailers();
    this.setState({
      trailers: trailers,
      trailerNumber: trailers.length ? trailers[0].value : "",
    });
  };

  updateOption = (field) => (option) => {
    if (!option) {
      return;
    }
    this.setState({
      [field]: option.value,
    });
  };

  getCurrentTrailers = () => {
    return this.props.currentDriverRoutes
      .filter(
        (route) =>
          route.trailerNumber &&
          route.trailerNumber !== constants.TRAILER_NUMBER_FOR_BOBTAIL
      )
      .map((item) => {
        return {
          label: item.trailerNumber,
          value: item.trailerNumber,
        };
      });
  };

  getConsolidatedRouteData = (stops) => {
    const initialData = {
      totalBills: 0,
      totalPieces: 0,
      totalHu: 0,
      totalWeight: 0,
    };

    const consolidatedArray = stops
      .filter(
        (stop) =>
          stop.stopType !== STOP_TYPES.PICKUP ||
          (stop.stopType === STOP_TYPES.PICKUP && stop.isStopCompleted)
      )
      .map((stop) => {
        const totalBills = stop.shipments.length;
        const shipmentInfo =
          stop.shipments?.reduce(
            (prevValue, currShipment) => ({
              totalWeight: prevValue.totalWeight + currShipment.weight ?? 0,
              totalPieces: prevValue.totalPieces + currShipment.pieces ?? 0,
              totalHu: prevValue.totalHu + currShipment.hu ?? 0,
            }),
            initialData
          ) ?? initialData;
        return { totalBills, ...shipmentInfo };
      });

    if (!consolidatedArray.length) {
      return initialData;
    }

    return consolidatedArray.reduce((prevValue, currvalue) => ({
      totalBills: prevValue.totalBills + currvalue.totalBills,
      totalWeight: prevValue.totalWeight + currvalue.totalWeight,
      totalPieces: prevValue.totalPieces + currvalue.totalPieces,
      totalHu: prevValue.totalHu + currvalue.totalHu,
    }));
  };

  onDropTrailer = () => {
    const routeByTrailerNumber = this.props.currentDriverRoutes.find(
      ({ trailerNumber }) => trailerNumber === this.state.trailerNumber
    );

    const filteredStops = routeByTrailerNumber.stops.filter(
      (stop) =>
      STOP_TYPES.TERMINAL!==stop.stopType
    );

    this.setState({
      shipmentData: this.getConsolidatedRouteData(filteredStops),
      filteredStops: filteredStops,
    });

    this.props.setPageName(Drop_Hook_Move_Page_Names.TRAILER_DROP);
  };
  goBack = () => {
    this.props.setPageName(Drop_Hook_Move_Page_Names.DROP_HOOK_MOVE);
  };

  render() {
    const { classes, isTrailerDropFormPage, routeData, isLoading } = this.props;
    const { dropType, trailerNumber, trailers, shipmentData, filteredStops } =
      this.state;
    const isSectionDisabled = trailers.length === 0;

    return (
      <React.Fragment>
        <Grid
          container
          className={`${classes.containerStyle} ${
            isSectionDisabled ? classes.sectionDisabled : null
          }`}
        >
          {isTrailerDropFormPage ? (
            <TrailerDropForm
              trailerNumber={trailerNumber}
              dropType={dropType}
              shipmentData={shipmentData}
              filteredStops={filteredStops}
              routeData={routeData}
              showHideLoader={this.props.showHideLoader}
              isLoading={isLoading}
              goBack={this.goBack}
            />
          ) : (
            <Grid xs={12}>
              <div className={classes.sectionTitle}>Trailer Drop</div>
              <div className={classes.flexRow}>
                <Select
                  textFieldProps={{
                    id: "DropType",
                    label: "Drop Type",
                    variant: "outlined",
                  }}
                  rootClass={classes.selectRoot}
                  value={dropType}
                  onChange={this.updateOption("dropType")}
                  isNotClearable={true}
                  data={DROP_TRAILER_OPTIONS}
                />
              </div>
              <div className={classes.flexRow}>
                <Select
                  textFieldProps={{
                    id: "TrailerNumber",
                    label: "Trailer Number",
                    variant: "outlined",
                  }}
                  rootClass={classes.selectRoot}
                  isNotClearable={true}
                  value={trailerNumber}
                  onChange={this.updateOption("trailerNumber")}
                  data={trailers}
                />
              </div>
              <div className={classes.actionButtons}>
                <Button
                  color="primary"
                  variant="contained"
                  className={classes.confirmButton}
                  onClick={this.onDropTrailer}
                  disabled={isLoading || isSectionDisabled}
                  classes={{
                    disabled: classes.disabledConfirmButton,
                  }}
                >
                  DROP TRAILER
                </Button>
              </div>
            </Grid>
          )}
        </Grid>
      </React.Fragment>
    );
  }
}

export default compose(
  withStyles(
    (theme) => ({
      ...styles(theme),
      ...localStyles(theme),
    }),
    { withTheme: true }
  )
)(TrailerDropDialog);
